import React, { useEffect, useState } from "react";
import {
  getAdminCategoryType,
  getInsitutionCategoryType,
} from "../../../services/adminApiService/adminCategoryType/AdminCategoryTypeApi";
import { getAdminAllSubCategory } from "../../../services/adminApiService/adminSubCategory/AdminSubCategory";
import { useCategoryFilter } from "../../../context/CategoryFilterContext";
import { Form } from "react-bootstrap";
import { useContext } from "react";
import { LocationContext } from "../../../context/LocationContext";

const InsitutionCategoryFilter = ({
  typeId,
  orgselectedCategory,
  setOrgSelectedCategory,
  selectedInsitutionCategory,
  setSelectedInsitutionCategory,
  setCurrentPage,
}) => {
  const [adminCategoryTypeData, setAdminCategoryTypeData] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const { setSelectedInsitutionCategoryId } = useCategoryFilter();
  const [insitutionCategoryTypeData, setinsitutionCategoryTypeData] = useState(
    [],
  );
  const { selectedDistrictId } = useContext(LocationContext);

  const getAdminCategoryTypeListApi = async (typeId) => {
    try {
      const response = await getAdminCategoryType(typeId);
      // console.log("responseCategoryTYpe", response);
      setAdminCategoryTypeData(response?.data);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  // const getinsituionCategoryTypeListApi = async (categoryId) => {
  //     try {
  //         const param = categoryId ? categoryId : "";
  //         const response = await getInsitutionCategoryType(param);
  //         // console.log("responseCategoryTYpe", response);
  //         setinsitutionCategoryTypeData(response?.data?.data);
  //     } catch (error) {
  //         console.error("Login error:", error);
  //     }
  // };

  const getinsituionCategoryTypeListApi = async (categoryId, districtId) => {
    try {
      const response = await getInsitutionCategoryType(categoryId, districtId);
      setinsitutionCategoryTypeData(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddFormChange = async (e) => {
    const { name, value } = e.target;

    setCategoryId(value);

    if (name === "category_type") {
      setOrgSelectedCategory(value);
      // if (value) {
      //     await getinsituionCategoryTypeListApi(value); // fetch by selected type
      // } else {
      //     await getinsituionCategoryTypeListApi(); // fetch all if no type selected
      // }
      setSelectedInsitutionCategory("");
      setSelectedInsitutionCategoryId("");
      setCurrentPage(1);
    }

    if (name === "insitution_category_type") {
      setSelectedInsitutionCategory(value);
      setSelectedInsitutionCategoryId(value);
      setCurrentPage(1); // set in context
    }
  };
  //   useEffect(() => {

  //          getinsituionCategoryTypeListApi();
  //     }, []);

  useEffect(() => {
    if (orgselectedCategory && selectedDistrictId) {
      getinsituionCategoryTypeListApi(orgselectedCategory, selectedDistrictId);
    }
  }, [orgselectedCategory, selectedDistrictId]);

  useEffect(() => {
    getAdminCategoryTypeListApi(typeId);
  }, [typeId]);
  return (
    <>
      <div className="d-flex w-100 mb-3 ">
        <div className="">
          <Form.Select
            defaultValue=""
            name="category_type"
            onChange={handleAddFormChange}
            id="inputState"
            // className="form-control"
            value={orgselectedCategory}
            style={{ width: "100%", padding: "11px 50px 10px 11px" }}
          >
            <option value="">Center Type</option>
            {adminCategoryTypeData?.data?.map((item) => (
              <option key={item?.id} value={item?.id}>
                {item?.category_name}
              </option>
            ))}
          </Form.Select>
        </div>

        <div className="mx-3">
          <Form.Select
            disabled={!orgselectedCategory || !selectedDistrictId}
            name="insitution_category_type"
            onChange={handleAddFormChange}
            // id="inputState"
            // className="form-control"
            value={selectedInsitutionCategory}
            style={{ width: "100%", padding: "11px 50px 10px 11px" }}
          >
            <option value="">Center Name</option>
            {insitutionCategoryTypeData?.length > 0 ? (
              insitutionCategoryTypeData.map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.name}
                </option>
              ))
            ) : (
              <option disabled>No Data Found</option>
            )}
          </Form.Select>
        </div>
      </div>
    </>
  );
};

export default InsitutionCategoryFilter;
